import { useEffect, useState } from 'react';
import {
  useApi,
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';

// Todo一覧表示用のサブコンポーネント
const TodoList = ({ todos }: { todos: any[] }) => (
  <div>
    <ul>
      {todos.map(todo => (
        <li key={todo.id}>
          <strong>{todo.title}</strong> <br />
          作成者: {todo.createdBy} <br />
          作成日: {new Date(todo.createdAt).toLocaleString()}
        </li>
      ))}
    </ul>
  </div>
);

export const TodoFetchComponent = () => {
  const todoApi = useApi(todoApiRef);
  const [todos, setTodos] = useState<any[]>([]);
  const [_loading, setLoading] = useState(true);
  const [_error, setError] = useState<string | null>(null);

  // Todo一覧取得
  useEffect(() => {
    const fetchTodos = async () => {
      try {
        const data = await todoApi.listTodos();
        setTodos(data.items);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchTodos();
  }, [todoApi]);

  return (
    <div>
      <TodoList todos={todos} />
    </div>
  );
};

// add

export const todoApiRef = createApiRef<TodoApi>({
  id: 'plugin.todo-api',
});

export interface TodoItem {
  id: string;
  title: string;
  createdBy: string;
  createdAt: string;
}

export interface TodoApi {
  listTodos(): Promise<{ items: TodoItem[] }>;
  createTodo(title: string): Promise<TodoItem>;
}

export class TodoApiClient implements TodoApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  async listTodos() {
    const baseUrl = await this.discoveryApi.getBaseUrl(
      'mysecondbackstageplugin',
    );
    const res = await this.fetchApi.fetch(`${baseUrl}/todos`);
    if (!res.ok) throw new Error(`Failed to fetch todos: ${res.status}`);
    return res.json() as Promise<{ items: TodoItem[] }>; // 型キャスト
  }

  async createTodo(title: string) {
    const baseUrl = await this.discoveryApi.getBaseUrl(
      'mysecondbackstageplugin',
    );
    const res = await this.fetchApi.fetch(`${baseUrl}/todos`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title }),
    });
    if (!res.ok) throw new Error(`Failed to create todo: ${res.status}`);
    return res.json() as Promise<TodoItem>;
  }
}
